import React from "react";
import { Link } from "react-router-dom";
class SignUpBanner extends React.Component {
  render() {
    return (
      <section className="section" style={{ background: "#003557" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center text-white">
                <h2 className="font-weight-normal">
                  Don't have an account yet?
                </h2>

                <p className="mx-auto text-muted cta-desc mt-4 pt-2">
                  <Link
                    to="/signup"
                    className="btn btn-custom-contact btn-rounded"
                  >
                    SIGN UP
                  </Link>
                </p>
                <p className="mx-auto text-white mt-4 pt-2">
                  Call Customer Support: 201-731-3839 (9AM-6PM EST)
                </p>

                <p className="mx-auto text-white mt-4 pt-2">
                  Email Us: support@mightywifi.net
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default SignUpBanner;



// WEBPACK FOOTER //
// ./src/pages/login/SignUpBanner.js